const add = (context, route) => {
  context.commit('ADD_ROUTE_HISTORY', route);
}

export default {
	add
}
